import React from "react"
import { Box } from "@staccx/bento"

const Main = ({ children }) => {
  return <Box>{children}</Box>
}

export default Main
